import "./utils/pdfPolyfills"; // must run before pdfjs-dist is evaluated
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import "./i18n"; // ✅ THIS IS REQUIRED — it initializes i18next

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

// Optional performance report
reportWebVitals();
